"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  gallery: {
    "& .mco-gallery-02-swiper-nav__prev": {
      background: "rgba(0, 0, 0, 0.5)",
      borderRadius: 0,
      width: 40,
      "&.swiper-button-disabled": {
        opacity: 0,
        pointerEvents: "none"
      },
      "& svg": {
        width: "8px !important",
        [theme.breakpoints.up("md")]: {
          width: "12px !important"
        }
      },
      [theme.breakpoints.up("md")]: {
        width: 56
      }
    },
    "& .mco-gallery-02-swiper-nav__next": {
      background: "rgba(0, 0, 0, 0.5)",
      borderRadius: 0,
      width: 40,
      "&.swiper-button-disabled": {
        opacity: 0,
        pointerEvents: "none"
      },
      "& svg": {
        width: "8px !important",
        [theme.breakpoints.up("md")]: {
          width: "12px !important"
        }
      },
      [theme.breakpoints.up("md")]: {
        width: 56
      }
    },
    "& .mco-gallery-02-thumb-swiper": {
      marginTop: theme.spacing(2),
      "&__item": {
        width: "40px !important",
        [theme.breakpoints.up("md")]: {
          width: "56px !important"
        }
      }
    }
  },
  fallbackImage: {
    paddingBottom: "62.71379703534778%",
    position: "relative",
    width: "100%",
    "& .mco-fallback-image": {
      left: 0,
      position: "absolute",
      top: 0
    }
  }
}));
var _default = exports.default = styles;